import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { OauthForApisField } from './OauthProviderField';

export const OauthForApisFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'OauthForApis',
    component: OauthForApisField,
  }),
);
